import * as React from "react";
import { SearchTablePage, ViewButton, EditButton } from "../../../../components";
import { useTl, useApiService } from "../../../../hooks";
import { useHistory } from "react-router";
import { CountryApi, CountrySearch, CountryGridDto } from "../../../../api";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { ERoutes } from "../../../../ERoutes";
import { useGlobalData } from "../../../../contexts";
import { Checkbox } from "@blueprintjs/core";
export interface ICountryListPageProps {}

export const CountryListPage: React.FunctionComponent<ICountryListPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(CountryApi);
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CountryGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.country}/${row.countryId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.country}/${row.countryId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        fieldName: "_flags",
        computed: true,
        disableSorting: true,
        autoFitContent: true,
        render: (row: CountryGridDto) => <img src={row.flagLink} alt={`${row.isoCode} flag`} height={25} width={25} />,
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.IsoCode),
        fieldName: "isoCode",
        autoFitContent: true,
      },
      {
        header: () => t(ETLCodes.BeautyJudgeEmail),
        fieldName: "emailForBeautyJudge",
        alignment: "center",
        autoFitContent: true,
        render: (row: CountryGridDto) => (
          <Checkbox checked={row.emailForBeautyJudge !== null && row.emailForBeautyJudge !== ""} disabled />
        ),
      },
    ],
    [history, t]
  );

  const searchCountryFunction = React.useCallback(
    (sObj) => api.baseSearch(CountrySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  const exportCountryFunction = React.useCallback(
    (sObj) => api.exportXlsFile(CountrySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  const searchCountryCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={searchCountryCriteriasFunction}
      searchFunction={searchCountryFunction}
      exportFunction={exportCountryFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Pays) }]}
    />
  );
};
